import React from 'react';

const CANVA_EMBED_URL =
  'https://www.canva.com/design/DAHMsJ8UKDE/a1u9NckbI_gd0MAZ4T4jYw/view?embed';

const CANVA_VIEW_URL =
  'https://www.canva.com/design/DAHMsJ8UKDE/a1u9NckbI_gd0MAZ4T4jYw/view?utm_content=DAHMsJ8UKDE&utm_campaign=designshare&utm_medium=embeds&utm_source=link';

const MidanComingSoon = () => {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Amiri:ital@1&family=Cairo:wght@400;700;900&family=Playfair+Display:ital,wght@1,500&family=Poppins:wght@600;700&display=swap');

        .mc-root, .mc-root * {
          box-sizing: border-box;
        }

        .mc-root {
          background: #000;
          color: #fff;
          width: 100%;
          min-height: 100vh;
          font-family: 'Cairo', sans-serif;
          display: flex;
          flex-direction: column;
          padding: clamp(20px, 4vw, 56px);
          overflow: hidden;
          position: relative;
        }

        /* ---------- Header ---------- */
        .mc-header {
          direction: ltr;
          font-family: 'Poppins', sans-serif;
          font-weight: 700;
          font-size: clamp(15px, 1.8vw, 21px);
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .mc-header .mc-divider {
          opacity: 0.45;
          font-weight: 300;
        }

        /* ---------- Hero row: text + logo ---------- */
        .mc-hero {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-between;
          gap: clamp(24px, 5vw, 48px);
          margin-top: clamp(24px, 6vw, 64px);
        }

        .mc-hero-text {
          flex: 1 1 440px;
          min-width: 280px;
        }

        .mc-soon-line {
          direction: rtl;
          display: flex;
          align-items: baseline;
          gap: 16px;
          flex-wrap: wrap;
        }
        .mc-soon-en {
          font-family: 'Playfair Display', serif;
          font-style: italic;
          font-weight: 500;
          font-size: clamp(24px, 3.4vw, 44px);
          color: #e9e9e9;
          white-space: nowrap;
        }
        .mc-soon-ar {
          font-family: 'Amiri', serif;
          font-size: clamp(24px, 3.4vw, 44px);
          color: #e9e9e9;
        }

        .mc-title {
          direction: rtl;
          text-align: right;
          font-family: 'Cairo', sans-serif;
          font-weight: 900;
          font-size: clamp(38px, 7.2vw, 88px);
          line-height: 1.18;
          margin: 10px 0 0;
        }

        /* ---------- Logo + spinning "coming soon" ring ---------- */
        .mc-logo-wrap {
          flex: 0 0 auto;
          width: clamp(200px, 28vw, 400px);
          aspect-ratio: 1;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .mc-ring {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          animation: mc-rotate 16s linear infinite;
        }
        @keyframes mc-rotate {
          from { transform: rotate(0deg); }
          to   { transform: rotate(360deg); }
        }
        @media (prefers-reduced-motion: reduce) {
          .mc-ring { animation: none; }
        }

        .mc-mark {
          position: relative;
          width: 42%;
          height: 42%;
        }

        /* ---------- Footer row: contact + description ---------- */
        .mc-footer {
          margin-top: auto;
          padding-top: clamp(32px, 7vw, 64px);
          display: flex;
          flex-wrap: wrap-reverse;
          justify-content: space-between;
          align-items: flex-end;
          gap: 28px;
        }

        .mc-contact {
          direction: ltr;
          font-family: 'Cairo', sans-serif;
          font-weight: 700;
          font-size: clamp(13px, 1.5vw, 17px);
          line-height: 1.85;
        }
        .mc-arrow {
          display: block;
          font-size: 1.4em;
          margin-bottom: 6px;
        }

        .mc-desc {
          direction: rtl;
          text-align: right;
          font-family: 'Cairo', sans-serif;
          font-weight: 700;
          font-size: clamp(14px, 1.6vw, 19px);
          line-height: 1.95;
          max-width: 580px;
          margin-inline-start: auto;
        }

        /* ---------- Mobile stacking ---------- */
        @media (max-width: 680px) {
          .mc-hero {
            flex-direction: column;
            align-items: flex-start;
          }
          .mc-logo-wrap {
            order: -1;
            margin: 0 auto 8px;
          }
          .mc-footer {
            flex-direction: column;
            align-items: flex-start;
          }
          .mc-desc {
            margin-inline-start: 0;
          }
        }
      `}</style>

      <div className="mc-root">
        <div className="mc-header">
          <span>Midan.sa</span>
          <span className="mc-divider">|</span>
          <span>@MidanLab</span>
        </div>

        <div className="mc-hero">
          <div className="mc-hero-text">
            <div className="mc-soon-line">
              <span className="mc-soon-en">Coming Soon…</span>
              <span className="mc-soon-ar">قريباً</span>
            </div>
            <h1 className="mc-title">نقوم بمحاكاة المهنه...</h1>
          </div>

          <div className="mc-logo-wrap">
            <svg className="mc-ring" viewBox="0 0 400 400">
              <defs>
                <path
                  id="mc-circle-path"
                  d="M 200,200 m -160,0 a 160,160 0 1,1 320,0 a 160,160 0 1,1 -320,0"
                />
              </defs>
              <text
                fill="#d8d8d8"
                fontFamily="Poppins, sans-serif"
                fontWeight={700}
                fontSize="21"
                letterSpacing="4"
              >
                <textPath href="#mc-circle-path" startOffset="0%">
                  COMING SOON &nbsp;•&nbsp; COMING SOON &nbsp;•&nbsp; COMING SOON &nbsp;•&nbsp; COMING SOON &nbsp;•&nbsp;
                </textPath>
              </text>
            </svg>

            <div className="mc-mark">
              <MidanMark />
            </div>
          </div>
        </div>

        <div className="mc-footer">
          <div className="mc-contact">
            <span className="mc-arrow">→</span>
            hello@Midan.sa
            <br />
            +966 53 703 7876
            <br />
            @MidanLab
          </div>

          <p className="mc-desc">
            ميدان.. منصة سعودية لسد فجوة 'التدريب غير الفعّال' وضبابية
            المسميات الوظيفية. نوفر بيئة محاكاة افتراضية وآمنة تتيح للمتدربين
            والموظفين ممارسة المهام اليومية الحقيقية لكل مسمى وظيفي بسوق العمل
            السعودي دون مخاطر.
          </p>
        </div>
      </div>
    </>
  );
};

/**
 * Placeholder logo mark (approximate shape/colors only).
 * Replace with the real Midan.sa logo SVG for an exact match.
 */
const MidanMark: React.FC = () => (
  <svg viewBox="0 0 200 200" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M35,150 L35,45 L65,45 L65,115 L100,70 L135,115 L135,45 L165,45 L165,150 L135,150 L135,120 L100,145 L65,120 L65,150 Z"
      fill="#4FA6E8"
    />
  </svg>
);

export default MidanComingSoon;
